import { InboxOutlined } from "@ant-design/icons";
import { ReactNode } from "react";
import { useTranslate } from "../i18n";

/**
 * What a list shows before it has anything in it.
 *
 * The title and hint default to the generic pair in the active language;
 * a list with something more specific to say passes its own.
 */
export const EmptyState = ({
    icon = <InboxOutlined />,
    title,
    hint
}: {
    icon?: ReactNode;
    title?: ReactNode;
    hint?: ReactNode;
}) => {
    const t = useTranslate();

    return (
        <div className="empty-state">
            <span className="empty-state__mark">{icon}</span>
            <span className="empty-state__title">{title ?? t("empty.default.title")}</span>
            <span className="empty-state__hint">{hint ?? t("empty.default.hint")}</span>
        </div>
    );
};
